(function () {
  if (window.KSEProductGallery) {
    window.KSEProductGallery.init(document);
    return;
  }

  function getOrCreateCarousel(element, options) {
    return window.Flickity.data(element) || new window.Flickity(element, options);
  }

  function initGallery(gallery) {
    if (gallery.dataset.galleryInitialized === 'true') return;

    const mainElement = gallery.querySelector('.image-carousel');
    const navElement = gallery.querySelector('.carousel-nav');
    const previousButton = gallery.querySelector('[data-gallery-previous]');
    const nextButton = gallery.querySelector('[data-gallery-next]');

    if (previousButton) previousButton.disabled = true;
    if (nextButton) nextButton.disabled = true;

    if (!window.Flickity || !mainElement || !navElement || !previousButton || !nextButton) return;

    const mainCarousel = getOrCreateCarousel(mainElement, {
      contain: true,
      pageDots: false,
      prevNextButtons: false,
    });
    const navCarousel = getOrCreateCarousel(navElement, {
      asNavFor: mainElement,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
    });

    const imageCount = mainCarousel.slides.length;

    function sync(index) {
      navCarousel.selectCell(index);
      previousButton.disabled = index <= 0;
      nextButton.disabled = index >= imageCount - 1;
    }

    function selectAdjacent(delta) {
      const targetIndex = Math.max(
        0,
        Math.min(mainCarousel.selectedIndex + delta, imageCount - 1),
      );

      if (targetIndex === mainCarousel.selectedIndex) return;
      mainCarousel.select(targetIndex);
    }

    previousButton.addEventListener('click', function () {
      selectAdjacent(-1);
    });
    nextButton.addEventListener('click', function () {
      selectAdjacent(1);
    });
    mainCarousel.on('change', sync);

    gallery.dataset.galleryInitialized = 'true';
    sync(mainCarousel.selectedIndex);
  }

  function init(root) {
    root.querySelectorAll('.product-gallery').forEach(initGallery);
  }

  window.KSEProductGallery = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
